import React from "react";

function FrontendAlertIcon({
  width = "266.95",
  height = "185",
  className = "",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 266.95 185"
      className={className}
    >
      <g
        id="_7182231_3582363"
        data-name="7182231_3582363"
        transform="translate(0 -54.952)"
      >
        <g id="Background_Complete" transform="translate(0 54.952)">
          <g id="Group_8540" data-name="Group 8540">
            <rect
              id="Rectangle_825"
              data-name="Rectangle 825"
              width="266.95"
              height="0.133"
              transform="translate(0 174.823)"
              fill="#ebebeb"
            />
            <rect
              id="Rectangle_826"
              data-name="Rectangle 826"
              width="17.684"
              height="0.133"
              transform="translate(222.518 183.417)"
              fill="#ebebeb"
            />
            <rect
              id="Rectangle_827"
              data-name="Rectangle 827"
              width="4.641"
              height="0.133"
              transform="translate(172.197 184.866)"
              fill="#ebebeb"
            />
            <rect
              id="Rectangle_828"
              data-name="Rectangle 828"
              width="10.247"
              height="0.133"
              transform="translate(211.737 178.459)"
              fill="#ebebeb"
            />
            <rect
              id="Rectangle_829"
              data-name="Rectangle 829"
              width="23.061"
              height="0.133"
              transform="translate(28.008 179.356)"
              fill="#ebebeb"
            />
            <rect
              id="Rectangle_830"
              data-name="Rectangle 830"
              width="3.381"
              height="0.133"
              transform="translate(55.822 179.356)"
              fill="#ebebeb"
            />
            <rect
              id="Rectangle_831"
              data-name="Rectangle 831"
              width="50.014"
              height="0.133"
              transform="translate(70.192 181.611)"
              fill="#ebebeb"
            />
            <path
              id="Path_3307"
              data-name="Path 3307"
              d="M144.35,205.965H41.255a3.051,3.051,0,0,1-3.048-3.048V58a3.051,3.051,0,0,1,3.048-3.047h103.1A3.051,3.051,0,0,1,147.4,58V202.917A3.051,3.051,0,0,1,144.35,205.965ZM41.255,55.086A2.917,2.917,0,0,0,38.34,58V202.918a2.917,2.917,0,0,0,2.914,2.914h103.1a2.917,2.917,0,0,0,2.913-2.914V58a2.917,2.917,0,0,0-2.913-2.914H41.255Z"
              transform="translate(-17.808 -54.952)"
              fill="#ebebeb"
            />
            <path
              id="Path_3308"
              data-name="Path 3308"
              d="M360.647,205.965h-103.1a3.051,3.051,0,0,1-3.047-3.048V58a3.051,3.051,0,0,1,3.047-3.047h103.1A3.051,3.051,0,0,1,363.694,58V202.917A3.051,3.051,0,0,1,360.647,205.965ZM257.552,55.086A2.917,2.917,0,0,0,254.638,58V202.918a2.917,2.917,0,0,0,2.913,2.914h103.1a2.917,2.917,0,0,0,2.914-2.914V58a2.917,2.917,0,0,0-2.914-2.914h-103.1Z"
              transform="translate(-118.625 -54.952)"
              fill="#ebebeb"
            />
          </g>
          <g
            id="Group_8548"
            data-name="Group 8548"
            transform="translate(71.199 89.854)"
          >
            <g
              id="Group_8543"
              data-name="Group 8543"
              transform="translate(73.518)"
            >
              <g
                id="Group_8542"
                data-name="Group 8542"
                transform="translate(0)"
              >
                <rect
                  id="Rectangle_838"
                  data-name="Rectangle 838"
                  width="23.775"
                  height="72.29"
                  transform="translate(64.823)"
                  fill="#e6e6e6"
                />
                <path
                  id="Path_3318"
                  data-name="Path 3318"
                  d="M421.3,373.687h6.349v-9.979h-13Z"
                  transform="translate(-339.049 -301.398)"
                  fill="#fafafa"
                />
                <rect
                  id="Rectangle_839"
                  data-name="Rectangle 839"
                  width="23.775"
                  height="72.29"
                  fill="#e6e6e6"
                />
                <rect
                  id="Rectangle_840"
                  data-name="Rectangle 840"
                  width="70.363"
                  height="68.855"
                  transform="translate(18.234)"
                  fill="#fafafa"
                />
                <path
                  id="Path_3319"
                  data-name="Path 3319"
                  d="M313.557,373.687h-6.348v-9.979h13Z"
                  transform="translate(-288.975 -301.398)"
                  fill="#fafafa"
                />
                <rect
                  id="Rectangle_841"
                  data-name="Rectangle 841"
                  width="60.514"
                  height="17.231"
                  transform="translate(23.159 25.658)"
                  fill="#f0f0f0"
                />
                <rect
                  id="Rectangle_842"
                  data-name="Rectangle 842"
                  width="60.514"
                  height="17.231"
                  transform="translate(23.159 46.572)"
                  fill="#f0f0f0"
                />
                <path
                  id="Path_3320"
                  data-name="Path 3320"
                  d="M373.244,295.6H336.738a2.5,2.5,0,0,1-2.5-2.5v-.839h41.5v.839A2.5,2.5,0,0,1,373.244,295.6Z"
                  transform="translate(-301.575 -268.097)"
                  fill="#fafafa"
                />
                <rect
                  id="Rectangle_843"
                  data-name="Rectangle 843"
                  width="60.514"
                  height="17.231"
                  transform="translate(23.159 4.743)"
                  fill="#f0f0f0"
                />
                <path
                  id="Path_3321"
                  data-name="Path 3321"
                  d="M373.244,256.424H336.738a2.5,2.5,0,0,1-2.5-2.5v-.839h41.5v.839A2.5,2.5,0,0,1,373.244,256.424Z"
                  transform="translate(-301.575 -249.838)"
                  fill="#fafafa"
                />
                <path
                  id="Path_3322"
                  data-name="Path 3322"
                  d="M373.244,334.769H336.738a2.5,2.5,0,0,1-2.5-2.5v-.839h41.5v.839A2.5,2.5,0,0,1,373.244,334.769Z"
                  transform="translate(-301.575 -286.355)"
                  fill="#fafafa"
                />
              </g>
            </g>
            <g
              id="Group_8547"
              data-name="Group 8547"
              transform="translate(0 25.361)"
            >
              <g id="Group_8546" data-name="Group 8546">
                <rect
                  id="Rectangle_844"
                  data-name="Rectangle 844"
                  width="18.797"
                  height="34.586"
                  transform="translate(2.847 12.343)"
                  fill="#e0e0e0"
                />
                <path
                  id="Path_3326"
                  data-name="Path 3326"
                  d="M206.856,341.429H143.913L137.3,294.5h62.944Z"
                  transform="translate(-137.301 -294.501)"
                  fill="#e6e6e6"
                />
                <path
                  id="Path_3327"
                  data-name="Path 3327"
                  d="M218.223,341.429H148.6L141.986,294.5h69.625Z"
                  transform="translate(-139.485 -294.501)"
                  fill="#f0f0f0"
                />
                <path
                  id="Path_3328"
                  data-name="Path 3328"
                  d="M162.273,340.5l-5.57-32.257h54.952l5.57,32.257Z"
                  transform="translate(-146.344 -300.905)"
                  fill="#fff"
                />
                <path
                  id="Path_3329"
                  data-name="Path 3329"
                  d="M195.053,340.5l-18.678-32.257h5.86L200.914,340.5Z"
                  transform="translate(-155.513 -300.905)"
                  fill="#fafafa"
                />
                <path
                  id="Path_3330"
                  data-name="Path 3330"
                  d="M210.681,340.5,192,308.241H202L220.674,340.5Z"
                  transform="translate(-162.798 -300.905)"
                  fill="#fafafa"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Shadow_1_" transform="translate(29.958 224.179)">
          <path
            id="_x3C_Path_x3E__280_"
            d="M103.517,0c17.837,0,49.35.73,49.35.73s54.167,3.018,54.167,5.315c0,3.339-46.346,6.045-103.517,6.045S0,9.384,0,6.045,46.346,0,103.517,0Z"
            fill="#e8e8e8"
          />
        </g>
        <g id="Warning" transform="translate(39.839 107.856)">
          <g id="Group_8556" data-name="Group 8556" transform="translate(0 0)">
            <g id="Group_8551" data-name="Group 8551">
              <path
                id="Path_3331"
                data-name="Path 3331"
                d="M76.032,208.687a.227.227,0,0,1-.226-.209l-1.186-14.256a.227.227,0,0,1,.208-.245.233.233,0,0,1,.245.208l1.186,14.256a.227.227,0,0,1-.208.245Z"
                transform="translate(-74.618 -172.655)"
                fill="#eab8b8"
              />
              <path
                id="Path_3332"
                data-name="Path 3332"
                d="M78.073,233.225a.227.227,0,0,1-.226-.209l-.359-4.316a.227.227,0,0,1,.453-.037l.359,4.316a.227.227,0,0,1-.208.245Z"
                transform="translate(-75.955 -188.725)"
                fill="#eab8b8"
              />
              <g
                id="Group_8549"
                data-name="Group 8549"
                transform="translate(0.014)"
              >
                <path
                  id="Path_3333"
                  data-name="Path 3333"
                  d="M197.046,239.293H86.809a5.681,5.681,0,0,1-5.54-5.114l-6.208-74.625a4.647,4.647,0,0,1,4.689-5.114H189.987a5.681,5.681,0,0,1,5.54,5.114l6.209,74.625A4.648,4.648,0,0,1,197.046,239.293Z"
                  transform="translate(-74.831 -154.227)"
                  fill="#fff"
                />
                <path
                  id="Path_3334"
                  data-name="Path 3334"
                  d="M196.86,239.32H86.623a5.887,5.887,0,0,1-5.752-5.309l-6.208-74.625a4.86,4.86,0,0,1,4.9-5.345H189.8a5.887,5.887,0,0,1,5.751,5.31l6.209,74.624a4.861,4.861,0,0,1-4.9,5.345Zm-117.3-84.853a4.434,4.434,0,0,0-4.476,4.884L81.3,233.975a5.453,5.453,0,0,0,5.328,4.918H196.86a4.433,4.433,0,0,0,4.477-4.883l-6.209-74.624a5.453,5.453,0,0,0-5.327-4.919H79.564Z"
                  transform="translate(-74.645 -154.041)"
                  fill="rgba(224,26,26,0.25)"
                />
              </g>
              <path
                id="Path_3335"
                data-name="Path 3335"
                d="M189.987,154.441H79.75a4.647,4.647,0,0,0-4.689,5.114H195.526A5.68,5.68,0,0,0,189.987,154.441Z"
                transform="translate(-74.817 -154.227)"
                fill="#e01a1a"
              />
              <g
                id="Group_8550"
                data-name="Group 8550"
                transform="translate(5.304 1.667)"
              >
                <path
                  id="Path_3336"
                  data-name="Path 3336"
                  d="M86.763,158.267a1,1,0,0,1-1.011,1.1,1.222,1.222,0,0,1-1.195-1.1,1,1,0,0,1,1.011-1.1A1.222,1.222,0,0,1,86.763,158.267Z"
                  transform="translate(-84.553 -157.164)"
                  fill="#fff"
                />
                <path
                  id="Path_3337"
                  data-name="Path 3337"
                  d="M95.163,158.267a1,1,0,0,1-1.011,1.1,1.221,1.221,0,0,1-1.194-1.1,1,1,0,0,1,1.011-1.1A1.221,1.221,0,0,1,95.163,158.267Z"
                  transform="translate(-88.468 -157.164)"
                  fill="#fff"
                />
                <path
                  id="Path_3338"
                  data-name="Path 3338"
                  d="M103.563,158.267a1,1,0,0,1-1.011,1.1,1.221,1.221,0,0,1-1.194-1.1,1,1,0,0,1,1.011-1.1A1.221,1.221,0,0,1,103.563,158.267Z"
                  transform="translate(-92.384 -157.164)"
                  fill="#fff"
                />
              </g>
            </g>
            <path
              id="Path_3339"
              data-name="Path 3339"
              d="M197.045,242.517h-92.73a4.516,4.516,0,0,1-4.4-4.065L95.581,186.4a3.694,3.694,0,0,1,3.727-4.065h92.73a4.516,4.516,0,0,1,4.4,4.065l4.33,52.049A3.693,3.693,0,0,1,197.045,242.517Z"
              transform="translate(-84.382 -167.23)"
              fill="#f0f0f0"
            />
            <path
              id="Path_3340"
              data-name="Path 3340"
              d="M205.182,196.815,176.454,231.4a8.217,8.217,0,0,0,4.584,13.281l46.6,10.077A8.217,8.217,0,0,0,237,243.678l-17.867-44.665A8.217,8.217,0,0,0,205.182,196.815Z"
              transform="translate(-121.197 -172.594)"
              fill="#263238"
              opacity="0.1"
            />
            <path
              id="Path_3341"
              data-name="Path 3341"
              d="M103.137,205.535,93.131,232.478a5.191,5.191,0,0,0,5.373,6.973l29.22-2.865a5.191,5.191,0,0,0,3.551-8.4L112.061,204.1A5.191,5.191,0,0,0,103.137,205.535Z"
              transform="translate(-83.093 -176.464)"
              fill="#263238"
              opacity="0.1"
            />
            <g
              id="Group_8553"
              data-name="Group 8553"
              transform="translate(65.505 11.773)"
            >
              <path
                id="Path_3342"
                data-name="Path 3342"
                d="M225.7,179.831l-26.856,38.994a8.639,8.639,0,0,0,5.975,13.464l49.367,6.57a8.639,8.639,0,0,0,8.885-12.391L240.56,180.9A8.639,8.639,0,0,0,225.7,179.831Z"
                transform="translate(-197.311 -176.092)"
                fill="#e01a1a"
              />
              <path
                id="Path_3343"
                data-name="Path 3343"
                d="M209.442,232.061a5.472,5.472,0,0,1-4.175-3.028,4.8,4.8,0,0,1,.252-4.911l26.924-39.093a4.527,4.527,0,0,1,4.427-1.883,5.473,5.473,0,0,1,4.175,3.028l22.568,45.679a4.8,4.8,0,0,1-.253,4.911,4.527,4.527,0,0,1-4.427,1.883Z"
                transform="translate(-200.762 -179.358)"
                fill="#fff"
              />
              <g
                id="Group_8552"
                data-name="Group 8552"
                transform="translate(29.753 17.574)"
              >
                <path
                  id="Path_3344"
                  data-name="Path 3344"
                  d="M257.1,209.04l3.144.419a4.036,4.036,0,0,1,3.475,4.108l-.211,4.1a3.528,3.528,0,0,1-.051.446l-2.237,12.36a3.32,3.32,0,0,1-3.8,2.688h0a4.057,4.057,0,0,1-3.471-3.665l-.907-12.773a3.6,3.6,0,0,1,0-.443l.211-4.106A3.319,3.319,0,0,1,257.1,209.04Zm-.251,27.528.857.114a3.61,3.61,0,0,1,3.108,3.674h0a2.969,2.969,0,0,1-3.442,2.8l-.857-.114a3.61,3.61,0,0,1-3.108-3.674h0A2.97,2.97,0,0,1,256.85,236.568Z"
                  transform="translate(-253.038 -209.007)"
                  fill="#e01a1a"
                />
              </g>
            </g>
            <g
              id="Group_8555"
              data-name="Group 8555"
              transform="translate(22.822 17.602)"
            >
              <path
                id="Path_3345"
                data-name="Path 3345"
                d="M124.914,190.881l-7.374,27.962a5.19,5.19,0,0,0,6.013,6.418l28.6-5.581a5.191,5.191,0,0,0,2.772-8.667L133.7,188.632A5.191,5.191,0,0,0,124.914,190.881Z"
                transform="translate(-117.364 -187.01)"
                fill="#e01a1a"
              />
              <path
                id="Path_3346"
                data-name="Path 3346"
                d="M125.542,224.787a3.159,3.159,0,0,1-2.894-.975,3.1,3.1,0,0,1-.8-2.924l7.392-28.033a2.635,2.635,0,0,1,2.09-1.948,3.159,3.159,0,0,1,2.894.975L155.5,214.321a3.1,3.1,0,0,1,.8,2.924,2.635,2.635,0,0,1-2.089,1.948Z"
                transform="translate(-119.407 -188.801)"
                fill="#fff"
              />
              <g
                id="Group_8554"
                data-name="Group 8554"
                transform="translate(11.695 10.24)"
              >
                <path
                  id="Path_3347"
                  data-name="Path 3347"
                  d="M140.88,206.585l1.822-.356a2.411,2.411,0,0,1,2.714,1.742l.672,2.442a2.287,2.287,0,0,1,.057.271l1.138,7.665a1.991,1.991,0,0,1-1.585,2.3h0a2.4,2.4,0,0,1-2.627-1.483l-2.959-7.306a2.374,2.374,0,0,1-.088-.258l-.673-2.445A2.007,2.007,0,0,1,140.88,206.585Zm5.155,16.168.5-.1a2.156,2.156,0,0,1,2.428,1.558h0a1.8,1.8,0,0,1-1.367,2.3l-.5.1a2.156,2.156,0,0,1-2.428-1.558h0A1.794,1.794,0,0,1,146.034,222.752Z"
                  transform="translate(-139.27 -206.19)"
                  fill="#e01a1a"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Character_1_" transform="translate(176.55 123.258)">
          <g id="Group_8565" data-name="Group 8565" transform="translate(0)">
            <g
              id="Group_8557"
              data-name="Group 8557"
              transform="translate(19.047 37.579)"
            >
              <path
                id="Path_3348"
                data-name="Path 3348"
                d="M383.164,206.035l-2.562.832,2.061,2.438a7.886,7.886,0,0,0,1.5-1.753.811.811,0,0,0-.292-1.1Z"
                transform="translate(-379.423 -206.035)"
                fill="#cb7f5c"
              />
              <path
                id="Path_3349"
                data-name="Path 3349"
                d="M377.03,210.557l1.536,1.866,1.7-1.429-2.061-2.438Z"
                transform="translate(-377.03 -207.724)"
                fill="#cb7f5c"
              />
            </g>
            <g
              id="Group_8559"
              data-name="Group 8559"
              transform="translate(33.467 15.454)"
            >
              <g id="Group_8558" data-name="Group 8558">
                <line id="Line_266" data-name="Line 266" opacity="0.2" />
              </g>
            </g>
            <path
              id="Path_3350"
              data-name="Path 3350"
              d="M383.3,145.678c.626,1.716,1.2,3.432,1.744,5.173s1.048,3.486,1.484,5.317l.156.7.073.367.036.183.009.046.01.07.019.14a5.765,5.765,0,0,1-.089,1.88,13.9,13.9,0,0,1-.951,2.881,27.45,27.45,0,0,1-2.827,4.884l-1.712-.947c.606-1.645,1.205-3.339,1.654-4.971a13.752,13.752,0,0,0,.457-2.342,2.654,2.654,0,0,0-.04-.818l-.142-.516-.184-.609c-.518-1.653-1.109-3.352-1.693-5.041s-1.168-3.4-1.731-5.09Z"
              transform="translate(-359.689 -128.023)"
              fill="#fe9f73"
            />
            <path
              id="Path_3351"
              data-name="Path 3351"
              d="M346.673,114.1c.044.206-.029.4-.162.433s-.277-.106-.32-.312.029-.4.162-.433S346.629,113.894,346.673,114.1Z"
              transform="translate(-337.315 -106.657)"
              fill="#263238"
            />
            <path
              id="Path_3352"
              data-name="Path 3352"
              d="M346.427,115.939a7.907,7.907,0,0,1-.6,2.005,1.193,1.193,0,0,0,1.012-.061Z"
              transform="translate(-337.08 -108.101)"
              fill="#630f0f"
            />
            <path
              id="Path_3353"
              data-name="Path 3353"
              d="M345.776,110.135a.123.123,0,0,1-.071-.224,1.212,1.212,0,0,1,1.118-.084.123.123,0,1,1-.094.228.967.967,0,0,0-.882.058A.126.126,0,0,1,345.776,110.135Z"
              transform="translate(-336.964 -103.941)"
              fill="#263238"
            />
            <path
              id="Path_3354"
              data-name="Path 3354"
              d="M356.8,116.724c.23,2.4-.11,4.716.427,6.8,0,0-.6,1.933-4.137,1.933-3.894,0-1.786-1.933-1.786-1.933,2.145-.508,2.151-2.085,1.838-3.566Z"
              transform="translate(-340.367 -108.626)"
              fill="#fe9f73"
            />
            <path
              id="Path_3355"
              data-name="Path 3355"
              d="M358.722,135.492c.3-.612.5-1.479-.124-1.7a16.038,16.038,0,0,0-5.713.131,1.41,1.41,0,0,0-1.011,1.694Z"
              transform="translate(-341.108 -119.931)"
              fill="#263238"
            />
            <path
              id="Path_3356"
              data-name="Path 3356"
              d="M395.2,401.431a3.373,3.373,0,0,0,.7-.271.067.067,0,0,0-.009-.124c-.116-.039-1.139-.377-1.409-.147a.215.215,0,0,0-.069.212.405.405,0,0,0,.218.315A.862.862,0,0,0,395.2,401.431Zm.489-.318a1.373,1.373,0,0,1-1,.183.275.275,0,0,1-.145-.217.083.083,0,0,1,.023-.087C394.709,400.872,395.274,400.989,395.687,401.113Z"
              transform="translate(-369.625 -298.936)"
              fill="#e01a1a"
            />
            <path
              id="Path_3357"
              data-name="Path 3357"
              d="M396.71,399.592a.068.068,0,0,0,.033-.019.067.067,0,0,0,.016-.067c-.011-.033-.266-.817-.65-1a.369.369,0,0,0-.3-.018h0a.22.22,0,0,0-.168.221c.014.323.712.8,1.036.886A.072.072,0,0,0,396.71,399.592Zm-.825-.991a.238.238,0,0,1,.164.022,1.622,1.622,0,0,1,.532.791c-.336-.149-.8-.524-.806-.715,0-.017,0-.058.08-.089h0Z"
              transform="translate(-370.451 -297.362)"
              fill="#e01a1a"
            />
            <path
              id="Path_3358"
              data-name="Path 3358"
              d="M340.778,407.331a3.347,3.347,0,0,0,.745-.1.068.068,0,0,0,.02-.123c-.1-.065-1.022-.629-1.337-.467a.214.214,0,0,0-.116.191.406.406,0,0,0,.139.357A.864.864,0,0,0,340.778,407.331Zm.55-.2a1.373,1.373,0,0,1-1.011-.052.274.274,0,0,1-.091-.245c0-.052.024-.07.043-.079C340.431,406.675,340.954,406.918,341.327,407.134Z"
              transform="translate(-333.237 -302.822)"
              fill="#e01a1a"
            />
            <path
              id="Path_3359"
              data-name="Path 3359"
              d="M342.678,405.875a.066.066,0,0,0,.037-.011.067.067,0,0,0,.03-.062c0-.035-.071-.856-.4-1.127a.369.369,0,0,0-.287-.087h0a.22.22,0,0,0-.215.177c-.06.317.509.941.8,1.1A.064.064,0,0,0,342.678,405.875Zm-.575-1.154a.239.239,0,0,1,.155.059,1.622,1.622,0,0,1,.336.892c-.293-.222-.656-.694-.62-.881,0-.017.011-.057.1-.068h0Z"
              transform="translate(-334.408 -301.466)"
              fill="#e01a1a"
            />
            <path
              id="Path_3360"
              data-name="Path 3360"
              d="M348.326,395.934H345.72l-.026-6.034H348.3Z"
              transform="translate(-336.991 -291.628)"
              fill="#fe9f73"
            />
            <path
              id="Path_3361"
              data-name="Path 3361"
              d="M399.921,389.366l-2.508.46-1.8-5.937,2.508-.46Z"
              transform="translate(-370.432 -287.293)"
              fill="#fe9f73"
            />
            <path
              id="Path_3362"
              data-name="Path 3362"
              d="M392.412,399.407l2.848-.674a.217.217,0,0,1,.25.124l.947,2.156a.4.4,0,0,1-.282.543c-1,.218-1.493.273-2.745.569-.771.182-2.343.638-3.407.89-1.041.246-1.411-.777-.995-.977a6.748,6.748,0,0,0,3-2.377A.654.654,0,0,1,392.412,399.407Z"
              transform="translate(-365.909 -297.541)"
              fill="#263238"
            />
            <path
              id="Path_3363"
              data-name="Path 3363"
              d="M334.487,407.265h2.845a.216.216,0,0,1,.215.178l.425,2.316a.4.4,0,0,1-.393.463c-1.026-.017-2.506-.078-3.8-.078-1.509,0-2.046.082-3.815.082-1.07,0-1.325-1.081-.873-1.179a12.317,12.317,0,0,0,4.756-1.58A1.249,1.249,0,0,1,334.487,407.265Z"
              transform="translate(-325.729 -303.26)"
              fill="#263238"
            />
            <g
              id="Group_8560"
              data-name="Group 8560"
              transform="translate(18.239 15.211)"
            >
              <path
                id="Path_3364"
                data-name="Path 3364"
                d="M379.012,138.632c2.431,1.711,3.164,6.122,3.164,6.122l-5.511,2.794a26.246,26.246,0,0,1-2.013-5.47C374.071,139.469,377.283,137.416,379.012,138.632Z"
                transform="translate(-374.582 -138.273)"
                fill="#bc1313"
              />
              <path
                id="Path_3365"
                data-name="Path 3365"
                d="M377.589,147.882l2.172,5.2-1.761.9a28.838,28.838,0,0,1-1.426-3.408Z"
                transform="translate(-375.916 -144.71)"
                opacity="0.2"
              />
            </g>
            <path
              id="Path_3366"
              data-name="Path 3366"
              d="M338.887,149.04c.019,2.908.195,6.526.628,11.016h13.938c.171-2.047-.684-11.7,1.39-21.36a1.277,1.277,0,0,0-1.053-1.531,32.448,32.448,0,0,0-3.292-.354,51.493,51.493,0,0,0-5.923,0c-.854.078-1.689.214-2.376.348a3.162,3.162,0,0,0-2.45,2.29,27.629,27.629,0,0,0-.763,5.431C338.916,146.075,338.878,147.451,338.887,149.04Z"
              transform="translate(-332.43 -122.025)"
              fill="#e01a1a"
            />
            <path
              id="Path_3367"
              data-name="Path 3367"
              d="M343.512,156.02a9.5,9.5,0,0,1-4.288,1.126c.026-.426.059-.829.1-1.208.432-.228.848-.436,1.241-.627Z"
              transform="translate(-332.657 -134.475)"
              opacity="0.2"
            />
            <g
              id="Group_8561"
              data-name="Group 8561"
              transform="translate(8.703 96.138)"
              opacity="0.2"
            >
              <path
                id="Path_3368"
                data-name="Path 3368"
                d="M345.7,389.905l.013,3.353h2.607l-.013-3.353Z"
                transform="translate(-345.695 -387.769)"
              />
              <path
                id="Path_3369"
                data-name="Path 3369"
                d="M398.122,383.434l-2.509.46.929,3.06,2.51-.46Z"
                transform="translate(-379.135 -383.434)"
              />
            </g>
            <path
              id="Path_3370"
              data-name="Path 3370"
              d="M353.68,102.219c.382,2.566.734,4.043-.255,5.659a3.363,3.363,0,0,1-5.953-.318c-1.018-2.134-1.472-5.971.765-7.6A3.4,3.4,0,0,1,353.68,102.219Z"
              transform="translate(-337.619 -96.928)"
              fill="#fe9f73"
            />
            <path
              id="Path_3371"
              data-name="Path 3371"
              d="M344.4,99.357c-.966-.424-.874-1.946-.58-2.588-1.119.385-2.736.605-3.028-.532s.7-1.5.093-2.476,1.32-2.036,2.219-.678,3.115.761,4.548-.55a1.263,1.263,0,0,1,1.962,1.522s3.136-.2,2.512,1.925-1.5,2.2-1.3,3.717c.137,1.024.257,3.1-.972,3.4C348.373,103.451,344.667,102.135,344.4,99.357Z"
              transform="translate(-333.673 -92.193)"
              fill="#263238"
            />
            <path
              id="Path_3372"
              data-name="Path 3372"
              d="M350,121.917c-.284.2-.578.423-.878.654.007.013.01.023.016.036a3.468,3.468,0,0,0,1.35,1.489c.187-.181.291-.791.643-.782,1.045.027,3.07-.41,3.405-1.59Z"
              transform="translate(-339.289 -111.976)"
              opacity="0.2"
            />
            <path
              id="Path_3373"
              data-name="Path 3373"
              d="M351.578,111.629a3.153,3.153,0,0,1-.248,1.676c-.3.6-.766.219-.95-.524-.165-.669-.208-1.789.221-2.118S351.494,110.877,351.578,111.629Z"
              transform="translate(-340.052 -104.502)"
              fill="#263238"
            />
            <g
              id="Group_8562"
              data-name="Group 8562"
              transform="translate(12.029 38.031)"
            >
              <path
                id="Path_3374"
                data-name="Path 3374"
                d="M355.771,207.4s2.188,19.912,3.523,27.371c1.462,8.169,9.035,33.81,9.035,33.81l4.668-.994s-5.212-23.988-5.914-32.076c-.762-8.778-2.319-28.112-2.319-28.112h-8.993Z"
                transform="translate(-355.771 -207.404)"
              />
            </g>
            <path
              id="Path_3376"
              data-name="Path 3376"
              d="M390.647,385.934c-.02,0,.794,1.7.794,1.7l5.252-1.118-.375-1.592Z"
              transform="translate(-367.105 -288.297)"
              fill="#263238"
            />
            <path
              id="Path_3377"
              data-name="Path 3377"
              d="M359.032,228.842c3.393.67,2.539,13.42,1.874,19.978-.807-4.636-1.906-13.555-2.648-19.886A1.187,1.187,0,0,1,359.032,228.842Z"
              transform="translate(-345.409 -183.717)"
              opacity="0.2"
            />
            <g
              id="Group_8563"
              data-name="Group 8563"
              transform="translate(5.951 38.031)"
            >
              <path
                id="Path_3378"
                data-name="Path 3378"
                d="M338.493,207.4s-1.111,19.481-1.134,27.426c-.024,8.264,1.818,35.325,1.818,35.325h4.414s1.188-26.577,1.7-34.694c.556-8.849,2.366-28.057,2.366-28.057h-9.161Z"
                transform="translate(-337.358 -207.404)"
              />
            </g>
            <path
              id="Path_3380"
              data-name="Path 3380"
              d="M340.494,392.176c-.02,0,.178,1.832.178,1.832h5.369l.208-1.635Z"
              transform="translate(-333.507 -293.152)"
              fill="#263238"
            />
            <g
              id="Group_8564"
              data-name="Group 8564"
              transform="translate(0 7.879)"
            >
              <path
                id="Path_3381"
                data-name="Path 3381"
                d="M331.936,127.838c-.527.052-.974.078-1.457.092s-.948.022-1.422.02a28.408,28.408,0,0,1-2.856-.166,21.763,21.763,0,0,1-2.886-.5,13.9,13.9,0,0,1-2.912-1.034l-.11-.054a1.722,1.722,0,0,1-.785-2.305,1.834,1.834,0,0,1,.164-.268,9.215,9.215,0,0,1,1.336-1.428c.446-.394.892-.749,1.341-1.087.9-.677,1.815-1.275,2.736-1.856s1.861-1.117,2.809-1.635,1.9-1.01,2.891-1.471a.983.983,0,0,1,1.012,1.672l-.011.008c-.83.636-1.684,1.268-2.512,1.915s-1.664,1.282-2.474,1.936-1.6,1.315-2.353,1.985c-.374.335-.731.677-1.053,1.018a6.624,6.624,0,0,0-.778.952l-.732-2.627a12.16,12.16,0,0,0,2.219.592,24.29,24.29,0,0,0,2.446.285c.834.053,1.681.081,2.53.081.424,0,.85,0,1.274-.015s.866-.03,1.235-.051l.045,0a1.975,1.975,0,0,1,.3,3.937Z"
                transform="translate(-319.33 -116.061)"
                fill="#fe9f73"
              />
            </g>
            <path
              id="Path_3382"
              data-name="Path 3382"
              d="M354.247,114.684l-1.658.366s-2.208-.274-2.713,1.39l1.308,1.117,2.02.319a1.52,1.52,0,0,0,.936-.152l.516-.267a.784.784,0,0,0,.42-.624l.122-1.31A.785.785,0,0,0,354.247,114.684Z"
              transform="translate(-339.793 -107.247)"
              fill="#fe9f73"
            />
            <path
              id="Path_3383"
              data-name="Path 3383"
              d="M341.3,144.009a12.26,12.26,0,0,1-5.942-.192l1.165-6.217s2.758-.242,4.48-.278C345.436,137.228,346.305,142.621,341.3,144.009Z"
              transform="translate(-330.067 -122.424)"
              fill="#bc1313"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FrontendAlertIcon;
